
import { useEffect, useState } from 'react'
import axios from 'axios'
//COMPONENTES PARTES

//INPORTAÇOES DE ICONES E IMAGENS
import IconChecked from '../../acets/img_icon/checked.svg'

import Select from 'react-select';
import MenuPainelAdmin from '../partils/AdminMenuPainel'
import IconNoChecked from '../../acets/img_icon/nochecked.svg'
import IconEdit from '../../acets/img_icon/edit.svg'

import ImgWppApi from  '../../acets/img/bgwppapi.png'

import TenancyColor from '../midllers/TenancyColor'
import { useNavigate } from 'react-router-dom';
import AdminHeader from '../partils/AdminHeader'

export default function AdminClienteFuncionario(){
    const TenancyColorUser = localStorage.getItem('localcolorusers')
    const tenancylocal = localStorage.getItem('ClienteTenancy')
    const navigate = useNavigate();
    //CONGIGURAÇÕES=============================
    const config={
        pageName:'WhatsApp',
        mainstring:'nome',
        url:'/api/clientefuncionario/',
        url2:'/api/baixas_cliente_funcionario/',
        search:'/api/clientefuncionario/search/',
        urlOptions1:'',
        params:'',
        messegerError:'ATENÇÃO - Preencha os campos para salvar os dados ;D',
    }
     //INICIANDO CICLO DE ESTADOS
     useEffect(()=>{
        rec();

        // eslint-disable-next-line react-hooks/exhaustive-deps
        },[])
    //STATES======================================
    
    const initialValues={ // DEFININDO UMA CONST PARA O STATE INICIAL 
      id_cliente: '', categoria:'',mensagem:'',	status: '',	observacao: '',	saldo:'', id_baixas_celiente_fornecedor:'',	id_clientefuncionario:'',	valor_baixa:'',	forma_pgto:'',
    }
    const [openNew,setOpenNew]=useState(false)// ABRIR TELA DE CADASTRAR E EDITAR
    const [values, setValues]=useState(initialValues) // INICIANDO UM STATE
    const [data, setData] = useState([])
    const [modalpagamentos, setModalpagamentos] = useState(false)
    const [dataBaixasCliente,setDataBaixasCliente]=useState([])
    
    const [dataWpptemplate,setDataWpptemplate]=useState([])
    const [dataCliente,setDataCliente]=useState([])
    const [qrcode,setQrcode]=useState()

    const [showboot,setShowboot]=useState(false)
    const [showautomacao,setShowautomacao]=useState(true)
    const [showtemplate,setShowtemplate]=useState(false)

    const [showcontato,setShowcontato]=useState(true)
    const [showcliente,setShowcliente]=useState(false)
    const [shownovocontato,setShownovocontato]=useState(false)
    const [newtemplate,setNewtemplate]=useState(false)

    const [contatoselecionado,setContatoselecionado]=useState({})
    const [mensagem,setMensagem]=useState()
    
    //FUNÇÕES=====================================
    const tlocal = localStorage.getItem('keyItemNameg')
    const headers = {
        'Content-Type': 'application/json',
        'token':tlocal,
    };
    function rec() {//CARREGAR ESTADOS E ATUALIZAR CICLO DE COMPONENTES
        axios.get('/api/cliente/',{headers}).then(resp=>
            setDataCliente(resp.data)
        )
        /*axios.get('/api/wpptemplate/',{headers}).then(resp=>{
            setDataWpptemplate(resp.data)
            console.log(resp.data)
        })*/
    }
    console.log('teste')
    //console.log(dataCliente)
    function onChange(ev) {//ALTERAR OS STATES DOS INPUTS
        const {name, value} = ev.target; //ESTRAIR O NAME E VALUE DO EV
        setValues({ ...values, [name]:value }); //SETANDO O VALUE EM NAME
    }
    function onSubmit(ev){//CADASTRAR NO BANCO DE DADOS, obs refatorado para tirar o if e else e usar o. ternario edit e cadastrar
        ev.preventDefault();
        if(values.mensagem===''||values.categoria===''){
          alert("Atencao, preencha todos os campos!")
           }else{
            axios[values.id_cliente?'put':'post']('/api/wpptemplate/',values,{headers}).then(()=>{
                //setOpenNew(false)
                setValues(initialValues);
                rec();
            })
          }
    }
    const dataclientefilter = dataCliente.filter(rend => rend.telefone != '')

    const renderclientes = dataclientefilter.map(rend =>
        <div className='linha w90 row pp' key={rend.id_cliente} onClick={()=>setContatoselecionado({'nome':rend.nome,'telefone':rend.telefone})}> 
            <div className='cont-circl b7 pp m5  cont-circ50pc column center c3 cell-none' 
                style={{width:'30px',height:'30px',opacity:0.4, backgroundColor:TenancyColorUser}}>
                Ev
            </div>
            <label className='fb fs09em pp m10'>{rend.nome}</label>
        </div>
    )
    const renderwpptemplate = dataWpptemplate.map(rend =>
        <div className='linha w90 row pp' key={rend.id_template} onClick={()=>setMensagem(rend.mensagem)}> 
            <label className='fs09em fb'>{rend.categoria}</label>
            <label className='fs06em pp m10'>{rend.mensagem}</label>
        </div>
    )
    
      //id_cliente	nome	placa	carro	endereco	telefone	email	status	observacao	codigo_acess	tenancyId
    return(
        <>
        {openNew&&           
            <div className='w100 h100 posifixedinicio column center z17' >
                <div className='w100 h100 posifixedinicio fundo-opaco z5' onClick={()=>(setOpenNew(false) & setValues(initialValues))}>
                </div>
                <div className='h20 w35 b2 cont-circ3 sombra column center z10 cell-tamanho90'>
                    <div className='w90 h20'>
                        <div className='w100'>
                            {values.id_clientefuncionario?<h5>Editar {config.pageName}</h5>:<h5>Cadastrar novo(a) {config.pageName}</h5>  }
                        </div>
                        <form onSubmit={onSubmit} autoComplete='off'>
                        </form>
                        
                        
                    </div>
                </div>
            </div>
        }
        
        <section className='h100 row between b31'>
            
            <MenuPainelAdmin/>
            <div className="h100 w80 cell-tamanho row center  celular">
                    
                <div className="w100 row between cell-tamanho celular">
                    <div className="h100 w100 cont-circ3 column  cell-tamanho cell-paddingcb10">
                        <div className='w90 row '> 
                            <h5 className='fs2em fb'>{config.pageName}</h5>
                            {<button 
                                style={{backgroundColor:TenancyColorUser}}
                                onClick={() =>
                                    axios.get(`wpp/start/${tenancylocal}`).then(resp => {
                                        setQrcode(resp.data.imagem); // <-- Aqui salva só a string base64
                                        console.log(resp.data.imagem);
                                    })
                                }>
                                    Qr code
                            </button>}
                        </div>
                      
                        
                        <div className='w90 h10 column cell-tamanho'>
                           
                            {qrcode && (
                                <img src={qrcode} alt="QR Code do WhatsApp" style={{ width: 200, height: 200 }} />
                            )}
                            <div className='w100 h90 c3 pcb10 row between'>
                                <div className='w30 h90 column between'>
                                    <div className='w100 row h7 between ma10b0'>
                                        <div className='w40 b2 h7 column center pp' onClick={()=>setShowcliente(true)&setShowcontato(false)&setShownovocontato(false)}> 
                                            <label className='fs09em fb pp'>
                                                Clientes
                                            </label> 
                                        </div> 
                                        <div className='w40 b2 h7 column center pp'  onClick={()=>setShowcliente(false)&setShowcontato(true)&setShownovocontato(false)}> 
                                            <label className='fs09em fb pp'>
                                                Mensagens
                                            </label> 
                                        </div> 
                                        <div className='w20 b2 h7 column center pp'  onClick={()=>setShowcliente(false)&setShowcontato(false)&setShownovocontato(true)}> 
                                            <label className='fs1p3em fb pp'>
                                                +
                                            </label> 
                                        </div> 
                                    </div>
                                    {showcliente&&
                                    <div className='w100 b2 he85 column overflowY'>
                                        <div className='w100 center column'>
                                            <div className='linha w90 column center h7 pp'>
                                                <label className='fs08em pp'>Contatos</label>
                                            </div>
                                            {renderclientes}
                                        </div>
                                    </div>
                                    }
                                    {showcontato&&
                                    <div className='w100 b2 h85 column'>
                                        <div className='linha w90 column center h7 pp'>
                                            <label className='fs08em pp'>Atualizar Mensagens</label>
                                        </div>
                                        <div className='linha w90 row pp'> 
                                            <div className='cont-circl b7 m10 cont-circ50pc column center c3' style={{width:'30px',height:'30px',opacity:0.4, backgroundColor:TenancyColorUser}}>Ev</div>
                                            <label className='fb fs09em'>Pedro Silva</label>
                                        </div>
                                    </div>
                                    }
                                    {shownovocontato&&
                                    <div className='w100 b2 h85 column'>
                                        <div className='linha w90 column center h7 pp'>
                                            <label className='fs08em pp'>Novo Contato</label>
                                        </div>
                                        <div className='linha w90 row pp'> 
                                            <div className='cont-circl b7 m10 cont-circ50pc column center c3' style={{width:'30px',height:'30px',opacity:0.4, backgroundColor:TenancyColorUser}}>Ev</div>
                                            <label className='fb fs09em'>Pedro Silva</label>
                                        </div>
                                    </div>
                                    }
                                </div>

                                <div className='w40 h90 column cell-tamanho70'>
                                    <div className='w100 h7 b2 ma10b0 row'>
                                        <div className='cont-circl b7 m10 cont-circ50pc column center c3' style={{width:'30px',height:'30px',opacity:0.4, backgroundColor:TenancyColorUser}}>Ev</div>
                                        <label className='fs09em fb'>{contatoselecionado.nome} +55{contatoselecionado.telefone}</label>
                                    </div>
                                    <div className='w100 h85 column start' 
                                        style={{
                                            backgroundImage: `url(${ImgWppApi})`,
                                            backgroundPosition: 'center',
                                            backgroundSize: 'cover',
                                            backgroundRepeat: 'no-repeat'
                                        }}
                                        >
                                        {contatoselecionado.nome?<>
                                        <div className='w90 h60 column start'>
                                            <div className='w100 row start'>
                                                <div className='w60 b2 cont-circ8 p10 ma10b0'>
                                                    <label>Olá! bom dia, quero um orçamento</label>
                                                    <div className='w100 fs06em fim'>11:30</div>
                                                </div>
                                            </div>
                                           <div className='w100 row end'>
                                                <div className='w60 b2 cont-circ8 p10 ma10b0'>
                                                    <label>Teste esse recurso esta em desenvolvimento!</label>
                                                    <div className='w100 fs06em fim'>11:30</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='w90'>
                                            <textarea className='' value={mensagem}>
                                                {mensagem}
                                            </textarea>
                                            <button className='w100' style={{backgroundColor:TenancyColorUser}}>
                                                Enviar Mensagem
                                            </button>
                                        </div>
                                        </>:<div className='w100 h70 column center'>Selecione o contato</div>
                                        }
                                    </div>
                                </div>

                                <div className='w25 h90 column cell-none '>
                                    <div className='w100 h7 b2 ma10b0 row center'>
                                        <div className='w33 fs08em fb cen pp' onClick={()=>setShowautomacao(true)&setShowboot(false)&setShowtemplate(false)}>
                                            Automação
                                        </div>
                                        <div className='w33 fs08em fb cen pp' onClick={()=>setShowautomacao(false)&setShowboot(true)&setShowtemplate(false)}> 
                                            Boot
                                        </div>
                                        <div className='w33 fs08em fb cen pp' onClick={()=>setShowautomacao(false)&setShowboot(false)&setShowtemplate(true)}>
                                            Templates
                                        </div>
                                    </div>
                                    {showautomacao&&
                                    <div className='w100 b2 h85 column'>                    
                                        <div className='linha w90 row between h7 pp'>
                                                <label className='fs06em pp'>Lista de Automações</label>
                                                 <label className='fs06em pp' onClick={()=>setNewtemplate(!newtemplate)}>
                                                   {showtemplate?'+ Novo template':'Fechar'}
                                                </label>
                                            </div>
                                           
                                            {newtemplate&&
                                            <form className='w90' onSubmit={onSubmit} autoComplete='off'>
                                                <label className='fs06em pp'>Titulo/Categoria:</label>
                                                <input style={{height:'10px'}} type='text' name="categoria"  onChange={onChange} value={values.categoria} autoComplete='off'></input>
                                                <label className='fs06em pp'>Mensagem:</label>
                                                <input style={{height:'10px'}} type='text' name="mensagem"  onChange={onChange} value={values.mensagem} autoComplete='off'></input>
                                                <button style={{height:'30px',width:'100%'}}>Salvar</button>
                                            </form>
                                            }           
                                        <div className='w90 b8 ma2 h5 pcb10 row between'>
                                            <div className='w100 row between'>
                                                <label className='fb'>Jose Silva</label>
                                                <div className='fs06em p5 cont-circ15 c3 baixado' >Confirmado</div>
                                                <label className='fb m5 pp w100 fim'>...</label>
                                            </div>
                                            <label className='w50 fs08em'> Revisão</label>
                                            <label className='50 fim fs06em'>07/08/25</label>
                                        </div>
                                        <div className='w90 b8 ma2 h5 pcb10 row between'>
                                            <div className='w100 row between'>
                                                <label className='fb'>Paulo Oliveira</label>
                                                <div className='fs06em p5 cont-circ15 c3 cancelado' >Pendencias</div>
                                                <label className='fb m5 pp w100 fim'>...</label>
                                            </div>
                                            <label className='w50 fs08em'> Fim garantia</label>
                                            <label className='50 fim fs06em'>07/08/25</label>
                                        </div>
                                    </div>
                                    }
                                    {showboot&&
                                    <div className='w100 b2 h85 column'>                    
                                        <div className='linha w90 row between h7 pp'>
                                                <label className='fs06em pp'>Lista de Boot</label>
                                                 <label className='fs06em pp' onClick={()=>setNewtemplate(!newtemplate)}>
                                                   {showtemplate?'+ Novo template':'Fechar'}
                                                </label>
                                            </div>
                                           
                                            {newtemplate&&
                                            <form className='w90' onSubmit={onSubmit} autoComplete='off'>
                                                <label className='fs06em pp'>Titulo/Categoria:</label>
                                                <input style={{height:'10px'}} type='text' name="categoria"  onChange={onChange} value={values.categoria} autoComplete='off'></input>
                                                <label className='fs06em pp'>Mensagem:</label>
                                                <input style={{height:'10px'}} type='text' name="mensagem"  onChange={onChange} value={values.mensagem} autoComplete='off'></input>
                                                <button style={{height:'30px',width:'100%'}}>Salvar</button>
                                            </form>
                                            }
                                        <div className='h50 fs09em column center'>EM CONSTRUÇÃO</div>
                                    </div>
                                    }
                                    {showtemplate&&
                                     <div className='w100 b2 he85 column overflowY'>
                                        <div className='w100 center column'>
                                            <div className='linha w90 row between h7 pp'>
                                                <label className='fs06em pp'>Lista de templates</label>
                                                 <label className='fs06em pp' onClick={()=>setNewtemplate(!newtemplate)}>
                                                   {showtemplate?'+ Novo template':'Fechar'}
                                                </label>
                                            </div>
                                           
                                            {newtemplate&&
                                            <form className='w90' onSubmit={onSubmit} autoComplete='off'>
                                                <label className='fs06em pp'>Titulo/Categoria:</label>
                                                <input style={{height:'10px'}} type='text' name="categoria"  onChange={onChange} value={values.categoria} autoComplete='off'></input>
                                                <label className='fs06em pp'>Mensagem:</label>
                                                <input style={{height:'10px'}} type='text' name="mensagem"  onChange={onChange} value={values.mensagem} autoComplete='off'></input>
                                                <button style={{height:'30px',width:'100%'}}>Salvar</button>
                                            </form>
                                            }
                                            {renderwpptemplate}
                                        </div>
                                    </div>
                                    }
                                </div>
                                   
                            </div>
                           
                        </div>     
                    </div>
                </div>
            </div>
            
        </section>
      </>
    )
}





